import { render, staticRenderFns } from "./DepositoCategoriaListado.vue?vue&type=template&id=b377a7cc"
import script from "./DepositoCategoriaListado.vue?vue&type=script&lang=js"
export * from "./DepositoCategoriaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports